import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dashboardMainWrapper: {
        marginTop: '80px',
    },
    appointmentTitle: {
        color: '#1e375f',
        fontFamily: "'Poppins', sans-serif",
        fontSize: '2rem',
        fontWeight: '600',
        marginBottom: '10px',
    },
    appointmentWrapper: {
        marginTop: '30px',
    },
    patientInfo: {
        fontSize: '1rem',
        fontFamily: "'Poppins', sans-serif",
        marginTop: '10px',
        whiteSpace: 'pre-line',
        padding: '10px',
        border: '1px solid #212121',
        wordBreak: 'break-word',
    },
    manageAppointment: {
        width: '100%',
        backgroundColor: '#1e375f',
        color: '#fff',
        border: '1px solid #212121',
        padding: '5px 15px',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#30538c',
            color: '#fff',
        },
    },
    messageBox: {
        fontSize: '1rem',
        fontFamily: "'Poppins', sans-serif",
        marginTop: '10px',
        whiteSpace: 'pre-line',
        padding: '10px',
        border: '1px solid #ebebeb',
        borderRadius: '5px',
    },
    actionResult: {
        fontFamily: "'Poppins', sans-serif",
    },
}));

export { useStyles };